export const enum PaymentsSecondaryMenuItems {
  INVOICES = 'invoices',
  PERFORMER_INVOICES = 'performerInvoices',
  GENERAL_LEDGERS = 'generalLedgers',
  SMART_CONTRACTS = 'smartContracts'
}
